var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "#828282",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33341 13.6667C2.30675 13.6667 0.666748 12.0267 0.666748 10L0.666748 3.00002C0.666748 1.52669 1.86008 0.333353 3.33341 0.333353C4.80675 0.333353 6.00008 1.52669 6.00008 3.00002L6.00008 8.66669C6.00008 9.58669 5.25341 10.3334 4.33341 10.3334C3.41341 10.3334 2.66675 9.58669 2.66675 8.66669V3.66669H4.00008V8.72669C4.00008 9.09335 4.66675 9.09335 4.66675 8.72669L4.66675 3.00002C4.66675 2.26669 4.06675 1.66669 3.33341 1.66669C2.60008 1.66669 2.00008 2.26669 2.00008 3.00002L2.00008 10C2.00008 11.2867 3.04675 12.3334 4.33341 12.3334C5.62008 12.3334 6.66675 11.2867 6.66675 10L6.66675 3.66669H8.00008V10C8.00008 12.0267 6.36008 13.6667 4.33341 13.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment2);
export default __webpack_public_path__ + "static/media/attachment_2.8c1dc097624655a0d481de22026c5059.svg";
export { ForwardRef as ReactComponent };